import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import ReactDropzone, { ImageFile } from 'react-dropzone';
import './Dropzone.css';
import SectorOfInterest from 'src/entities/SectorOfInterest';
import ImageContainer from 'src/modules/commons/images/Image.container';
import PhysicalPersonData from 'src/value-objects/PhysicalPersonData';

export interface UserProfileFormComponentProps {
  formData: PhysicalPersonData;
  handleChange: (key: string) => (value: string | File | boolean | SectorOfInterest) => void;
  profilePicture?: File;
  sectors: SectorOfInterest[];
}

class UserProfileFormComponent extends React.Component<UserProfileFormComponentProps> {

  public render(): React.ReactNode {

    return (
      <section>
        <div
          className="accordion-toggle question-toggle collapsed pointer"
          data-toggle="collapse"
          data-parent="#faqAccordion"
          data-target="#question49"
        >
          <div className="icon-title">
            <img
              alt="More"
              className="icon"
              src="/img/user-check.png"
            />
            <h4 className="inline-block f-s-18">
              <strong>
                Tu perfil de usuario
              </strong>
              <span className="d-arrow-up" /></h4>
            <div className="gap-20" />
          </div>
        </div>
        <div
          id="question49"
          className="collapse"
        >
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <ReactDropzone
                className="dropzone text-center pointer"
                onDrop={(files: ImageFile[]) => {
                  if (files[0]) {
                    this.props.handleChange('profilePicture')(files[0]);
                  }
                }}
                multiple={false}
                accept="image/*"
              >
                <ImageContainer
                  alt="profile picture"
                  url={
                    this.props.profilePicture ||
                    this.props.formData.profilePicture && this.props.formData.profilePicture.url
                  }
                  defaultImagePath="/img/pic.png"
                />
                <div className="gap-10" />
                <p className="text-center">
                  Arrastre su foto de perfil / Clique aquí...
                </p>
              </ReactDropzone>
              <div className="gap-20" />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Usuario Facebook"
                  type="text"
                  value={this.props.formData.facebookProfile || ''}
                  required={false}
                  onChange={(value) => this.props.handleChange('facebookProfile')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Usuario Twitter"
                  type="text"
                  value={this.props.formData.twitterProfile || ''}
                  required={false}
                  onChange={(value) => this.props.handleChange('twitterProfile')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Usuario LinkedIn"
                  type="text"
                  value={this.props.formData.linkedinProfile || ''}
                  required={false}
                  onChange={(value) => this.props.handleChange('linkedinProfile')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
          </div>
          <div className="gap-20" />
          <p className="f-s-16">
            <strong>
              Sectores de interés
            </strong>
          </p>
          <div className="row">
            {this.props.sectors.map(
              (sector, index) => (
                <div className="col-sm-6 col-md-4" key={index}>
                  <div className="checkbox">
                    <input
                      id={'checkbox' + index}
                      type="checkbox"
                      defaultChecked={
                        this.props.formData.sectorsOfInterest &&
                        this.props.formData.sectorsOfInterest
                          .some((selectedSector: SectorOfInterest) => selectedSector.id === sector.id)
                      }
                      onClick={() => this.props.handleChange('sectorsOfInterest')(sector)}
                    />
                    <label htmlFor={'checkbox' + index}>
                      {sector.name}
                    </label>
                  </div>
                </div>
              )
            )}
          </div>
          <div className="gap-20" />
          <div className="control">
            <InputContainer
              label=" "
              type="textarea"
              placeholder="Presentación..."
              value={this.props.formData.about || ''}
              required={false}
              onChange={(value) => this.props.handleChange('about')(value)}
            />
          </div>
          <div className="gap-20" />
          <div className="control">
            <InputContainer
              label=" "
              type="textarea"
              placeholder="Objetivos de inversión..."
              value={this.props.formData.investmentGoal || ''}
              required={false}
              onChange={(value) => this.props.handleChange('investmentGoal')(value)}
            />
          </div>
          <div className="gap-20" />
        </div>
      </section>
    );
  }
}

export default UserProfileFormComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/physical-person-update/forms/UserProfileForm.component.tsx